import styled, { css } from 'styled-components';

import { StyledMain } from '@pega/cosmos-react-build/lib/components/AppShell/AppShell.styles';

export const StyledContainer = styled(StyledMain)(() => {
  return css`
    margin-inline-start: 0;
    min-height: 100vh;
  `;
});
